<template>
  <div class="pb-30">
    <van-row class="mt-40 mb-40" type="flex" align="center">
      <van-col span="12" align="right" @click="bindChoose(1)">
        <div :class="['mr-30', type == 1 ? 'choose' : 'no-choose']">
          待办预约
        </div>
      </van-col>
      <van-col span="12" align="left" @click="bindChoose(2)">
        <div :class="['ml-30', type == 2 ? 'choose' : 'no-choose']">
          历史预约
        </div>
      </van-col>
    </van-row>

    <ul v-infinite-scroll="loadMore" infinite-scroll-distance="20">
      <li
        class="list-item"
        v-for="(item, index) in list"
        :key="index"
        @click="bindGoDetail(item)"
      >
        <van-row class="pb-20 b-b mb-40" type="flex" align="center">
          <van-col align="left" span="12">
            <div class="ft-30 c-66">
              预约号：<span class="c-black fw-blod">{{ item.reserveNo }}</span>
            </div>
          </van-col>
          <van-col align="right" span="12" v-if="type == 2">
            <div
              class="c-a8 ft-24"
              style="line-height: 2"
              v-if="item.status == 3"
            >
              已取消
            </div>
            <div
              class="c-a8 ft-24"
              style="line-height: 2"
              v-if="item.status == 2"
            >
              已过期
            </div>
            <div
              class="c-a8 ft-24"
              style="line-height: 2"
              v-if="item.status == 1"
            >
              已出票
            </div>
          </van-col>

          <van-col align="right" span="12" >
            <div
              @click.stop="cancel(item)"
              class="flex align-center"
              style="justify-content: flex-end"
              v-if="type == 1"
            >
              <!--  -->
              <img src="@/assets/mine/cancel_icon.png" class="cancel-icon" />
              <span
                class="c-orange ft-24"
                style="line-height: 2"
              >
                取消预约
              </span>
            </div>
          </van-col>
        </van-row>
        <div class="mb-40 fw-blod ft-30 c-black">
          {{ item.netName }}
        </div>
        <div class="flex align-center mb-40">
          <div class="ft-28 c-66 item-label">业务名称：</div>
          <div class="ft-28 c-black flex-1">{{ item.bizName }}</div>
        </div>
        <div class="flex mb-40">
          <div class="ft-28 c-66 item-label">办理地址：</div>
          <div class="ft-28 c-black flex-1">
            {{ item.net.address }}
          </div>
        </div>
        <div :class="['flex', 'align-center']">
          <div class="ft-28 c-66 item-label">预约时段：</div>
          <div class="ft-28 c-blue flex-1 fw-blod">
            {{ item.reserveDate + " " + item.startTime + "-" + item.endTime }}
          </div>
        </div>
        <van-row class="pt-20 b-t mt-40" type="flex" align="center"  v-if="type == 1 && nowDate == item.reserveDate">

          <van-col align="right" span="24">
            <div class="flex align-center" style="justify-content: flex-end"  @click.stop="getTicketByReserve(item)">
              <img src="@/assets/mine/eval_icon.png" class="cancel-icon" />
              <span class="c-orange ft-24" style="line-height: 2">
                在线取号
              </span>
            </div>
          </van-col>
        </van-row>
        <!-- <div
          v-if="type == 1"
          class="ft-20 c-66 flex align-center mt-20"
          @click.stop="bindGoNotice"
        >
          <img src="@/assets/mine/notice_icon.png" class="notice-icon" />
          <div>办件须知</div>
        </div> -->
      </li>
      <li align="middle" class="c-orange ft-24" v-if="type == 1 && mergeButton && !errStatus && !loading">
          <a @click="open=true">没有找到预约记录？点此关联</a>
      </li>
    </ul>

    <div class="text-center" v-if="!errStatus && !loading && list.length == 0">
      <img src="@/assets/mine/no_list_bg.png" class="no-list" />
      <div class="ft-24 c-a8">
        暂无{{ type == 1 ? "待办预约" : "历史预约" }}
      </div>
    </div>

    <div class="text-center pt-310" v-if="loading">
      <van-loading size="24px">加载中...</van-loading>
    </div>

    <div v-if="errStatus && !loading" class="text-center pt-310">
      <div class="ft-24 c-a8">网络错误请重试</div>
      <div class="err-btn" @click="bindChoose(type)">重试</div>
    </div>

    <van-dialog v-show="open" title="请输入预约用户信息" show-cancel-button :lazy-render="false" @confirm="mergeConfirm"
                :before-close="onBeforeClose">
      <van-form ref="userInfoForm" @submit="clickSubmit">
        <van-field
            v-model="userInfo.name"
            label="姓名"
            name="name"
            class="ft-26"
            input-align="right"
            error-message-align="right"
            :rules="[{ required: true, message: '请输入姓名' }]"
        />
        <van-field
            v-model="userInfo.idnum"
            label="身份证号"
            name="idnum"
            class="ft-26"
            input-align="right"
            error-message-align="right"
            :rules="[{ required: true, message: '请输入身份证号' },{ validator: numValidator, message: '请输入正确的身份证号' }]"
        />
        <van-field
            v-model="userInfo.tel"
            label="手机号码"
            name="tel"
            class="ft-26"
            input-align="right"
            error-message-align="right"
            :rules="[{ required: true, message: '请输入手机号码' },{ validator: phoneValidator, message: '请输入正确的手机号码' }]"
        />
      </van-form>
    </van-dialog>

  </div>
</template>

<script>
import { reserveTodoList, reserveHisList, cancelReserve, getTicketByReserve, mergeReserveList } from "@/api/index";
import {Dialog, Toast} from "vant";
import timeUtil from "@/util/calendar";
export default {
  name: "ticketList",
  data() {
    return {
      list: [],
      listMore: true,
      loading: true,
      errStatus: false,
      type: "1", // 1-代办预约，2-历史预约
      open:false,
      mergeButton:false,
      userInfo:{
        name:'',
        idnum:'',
        tel:''
      },
      nowDate: timeUtil.dateFormat(new Date()),
      isNeedUpdate: false,
    };
  },
  activated() {
    this.init();
    if (process.env.VUE_APP_WEIXIN == '0' && process.env.VUE_APP_SMS == '0') {
      this.mergeButton = true;
    }
  },
  beforeDestroy() {
    Toast.clear();
  },
  beforeRouteLeave(to, from, next) {
    if (to.path.indexOf("reserveDetail") == -1) {
      from.meta.keepAlive = false;
    } else {
      from.meta.keepAlive = true;
    }
    next();
  },
  methods: {
    init(lastId) {
      let clientId = this.$route.params.clientId;

      //  预约代办
      reserveTodoList(clientId, lastId)
        .then((response) => {
          this.loading = false;
          this.errStatus = false;
          this.undapteList(response, lastId);
          // console.log(response, 999);
        })
        .catch((err) => {
          this.loading = false;
          this.errStatus = true;
        });
    },

    // 历史预约
    initHistory(lastId) {
      let clientId = this.$route.params.clientId;

      reserveHisList(clientId, lastId)
        .then((response) => {
          // console.log(response, 11111);
          this.loading = false;
          this.errStatus = false;
          this.undapteList(response, lastId);
        })
        .catch((err) => {
          this.loading = false;
          this.errStatus = true;
        });
    },
    undapteList(response, lastId) {
      if (response.data.length == 0) {
        this.listMore = false;
      } else {
        this.listMore = true;
      }
      if (!lastId) {
        this.list = response.data || [];
      } else {
        this.list = this.list.concat(response.data);
      }
    },
    loadMore() {
      if (!this.listMore || this.list.length == 0 || this.type == 1) return;
      let lastId = this.list[this.list.length - 1].reserveId;

      this.initHistory(lastId);
    },
    cancel(item) {
      Dialog.confirm({
        message: "确定取消吗",
        className: "cancal-confirm",
        overlayClass: "pop-confirm",
        confirmButtonColor: "#1577ed",
        cancelButtonColor: "#a8a8a8",
      })
        .then(() => {
          cancelReserve(item.reserveId)
            .then((response) => {
              // console.log(response,'ppp');
              this.init(this.clientId);
            })
            .catch((err) => {
              // Dialog.alert(err.data.msg);
            });
        })
        .catch(() => {});
    },
    getTicketByReserve(item) {
      Dialog.confirm({
        message: "确定取号吗？确保您已经到达大厅。取票成功后，可在我的票号列表查看待叫号码",
        className: "cancal-confirm",
        overlayClass: "pop-confirm",
        confirmButtonColor: "#1577ed",
        cancelButtonColor: "#a8a8a8",
      })
          .then(() => {
            getTicketByReserve({reserveId:item.reserveId})
                .then((response) => {
                  this.$router.push({
                    path: `detailTicket?id=${response.data}&from=2`,
                  });
                })
                .catch((err) => {
                  // Dialog.alert(err.data.msg);
                });
          })
          .catch(() => {});
    },
    phoneValidator(val) {
      return /^1[3456789]\d{9}$/.test(val);
    },
    numValidator(val) {
      return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(val);
    },
    mergeConfirm(){
      this.$refs.userInfoForm.submit();
    },
    onBeforeClose(action, done) {
      if (action === "confirm") {
        return done(false);
      } else {
        return done();
      }
    },
    clickSubmit() {
      mergeReserveList(this.userInfo)
          .then((res) => {
            if(res.data>0){
              Toast.success("查询到"+res.data+"条预约记录");
              this.open = false;
              this.init();
            }else{
              Toast.fail("没有查询到可以关联的预约记录！");
            }
          });
    },
    bindChoose(type) {
      this.type = type;
      this.loading = true;
      this.list = [];
      if (type == 2) {
        this.initHistory();
      } else {
        this.init();
      }
    },
    bindGoNotice(item) {
      this.$router.push({ path: `notice` });
    },
    bindGoDetail(item) {
      this.$router.push({
        path: `reserveDetail?id=${item.reserveId}&type=2&from=2`,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.choose {
  font-size: 36px;
  color: $blue;
}
.no-choose {
  font-size: 30px;
  color: #333;
}
.list-item {
  background-color: #fff;
  box-shadow: 0 0px 20px 1px #c8c8c8;
  border-radius: 8px;

  margin: 0 40px 40px;
  box-sizing: border-box;
  padding: 30px 30px 20px;
  .notice-icon {
    width: 24px;
    height: 24px;
    margin-right: 10px;
  }
  .item-label {
    width: 160px;
  }
}
.no-list {
  width: 668px;
  height: 195px;
  margin: 310px 0 30px 0;
}
.cancal-confirm {
  border-radius: 8px;
  .van-dialog__message {
    font-size: 38px;
  }
  .van-button__text {
    font-size: 30px;
  }
}
.pop-confirm {
  background-color: rgba(0, 0, 0, 0.2);
}
.err-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: $blue;
  font-size: 28px;
  width: 160px;
  height: 60px;
  border-radius: 30px;
  margin: 0 auto;
  margin-top: 30px;
  color: #fff;
}
.cancel-icon {
  width: 32x;
  height: 32px;
  margin-right: 15px;
}
</style>
